import {jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {Suspense, useCallback, useEffect} from 'react'
import {useHistory, useLocation} from 'react-router'
import ReviewRequestToJoinOrgModal from '~/components/ReviewRequestToJoinOrgModal'
import reviewRequestToJoinOrgModalQuery, {

} from '../__generated__/ReviewRequestToJoinOrgModalQuery.graphql'
import useModal from '../hooks/useModal'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import useRouter from '../hooks/useRouter'

const ReviewRequestToJoinOrgRoot = () => {
  const {match} = useRouter()
  const {params} = match
  const {requestId} = params
  const queryRef = useQueryLoaderNow(
    reviewRequestToJoinOrgModalQuery,
    {requestId},
    'network-only'
  )

  const location = useLocation()
  const history = useHistory()

  const onClose = useCallback(() => {
    const state = location.state
    history.replace(_nullishCoalesce(_optionalChain([state, 'optionalAccess', _ => _.backgroundLocation]), () => ( '/meetings')))
  }, [location])

  const {openPortal, closePortal, modalPortal} = useModal({
    id: 'reviewRequestToJoinOrgModal',
    onClose
  })

  useEffect(() => {
    openPortal()
    return () => {
      closePortal()
    }
  }, [])

  return (
    _jsx(Suspense, { fallback: '', children: 
      queryRef &&
        modalPortal(_jsx(ReviewRequestToJoinOrgModal, { closePortal: closePortal, queryRef: queryRef,} ))
    })
  )
}

export default ReviewRequestToJoinOrgRoot
